module.exports = __webpack_public_path__ + "img/split_view_mode.cf7b2906.svg";